const compareByPosition = (a, b) => {
  const ap =
    a && Number.isFinite(a.position) ? a.position : Number.MAX_SAFE_INTEGER;
  const bp =
    b && Number.isFinite(b.position) ? b.position : Number.MAX_SAFE_INTEGER;

  if (ap !== bp) {
    return ap - bp;
  }

  // Stable id tiebreaker so duplicate positions always order the same way
  const aId = a && (a.id ?? a._id) != null ? String(a.id ?? a._id) : '';
  const bId = b && (b.id ?? b._id) != null ? String(b.id ?? b._id) : '';
  return aId.localeCompare(bId);
};

const sortByPosition = (rows) => {
  if (!Array.isArray(rows)) {
    return rows;
  }
  return [...rows].sort(compareByPosition);
};

module.exports = { compareByPosition, sortByPosition };
